import React from 'react';
import { Flex, Text } from '@opendoor/bricks/core';
import { ColorScheme } from '@opendoor/bricks/system/theme';

interface BadgeWithoutIconProps {
  currentText: string;
  backgroundColor?: ColorScheme;
  color?: ColorScheme;
}

/**
 * Badges for status without icon
 *
 * storybook-check-ignore
 */
export const BadgeWithoutIcon: React.FC<BadgeWithoutIconProps> = ({
  currentText,
  backgroundColor,
  color,
}) => {
  return (
    <Flex
      backgroundColor={backgroundColor || 'neutrals0'}
      border="2px solid"
      borderColor="neutrals20"
      height="28px"
      flexDirection="row-reverse"
      borderRadius="roundedSquare"
      justifyContent="center"
      alignItems="center"
      py="3"
      px="3"
      mb="3"
    >
      <Text
        fontSize="s00"
        lineHeight="s000"
        color={color}
        fontWeight="semibold"
        data-testid="badge-text"
        alignSelf="center"
      >
        {currentText}
      </Text>
    </Flex>
  );
};
